export default {
  id: 'teams_invite',
  title: 'Invite message',
  type: 'Group',
  description: 'Invite users to join the platform.',
  body: `<div>
    <p>[[INPUT_INTRODUCTION_TEXT]]</p>
    <a style='display: inline-block; color:#333' href='{{PLATFORM_LINK}}'>
      <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>[[INPUT_JOIN_BUTTON]]</pre>
    </a>
  </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Hi all, ...',
      defaultValue: '<p>Hi all,</p><p>I am pleased to inform you that you can now join to our new referral platorm.</p><p>All you need to do is to click on the link below to start earning valuable rewards by sharing jobs and company content with your network.</p>',
      type: 'HTML'
    },
    INPUT_JOIN_BUTTON: {
      label: 'Button text',
      type: 'STRING',
      placeholder: 'Join now',
      defaultValue: 'Join now',
    },
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/invite.js